export const emailRegex = /[^>()[\]\\,;:@\s]{0,191}@[^>()[\]\\,;:@\s]{1,64}/;

export function isEmail(email: string) {
  return emailRegex.test(email);
}
